enum CommentsOrderBy {
  SOCIAL = 'social',
  REVERSE_TIME = 'reverse_time',
  TIME = 'time',
}

export default CommentsOrderBy;
